import { IPaginate } from 'interfaces';
import React, {
  useCallback, useEffect, useState,
} from 'react';
import { GoChecklist } from 'react-icons/go';
import { useHttp } from 'hooks/http';
import { useQuery } from 'react-query';
import { Box, Grid } from '@material-ui/core';
import HeaderFilterPlus from '../../../components/Headers/FilterPlus';
import Layout from '../../../components/Layout';
import { Container } from './styles';
import Pagination from '../../../components/Pagination';
import Card from './Card';
import { useHistory } from 'react-router-dom';

interface IFilter {
    search?: string;
}

const ServiceList : React.FC = () => {
  const { httpGet } = useHttp();
  const history = useHistory();
  const [services, setServices] = useState([]);
  const [filter, setFilter] = useState<IFilter>({} as IFilter);
  const [paginate, setPaginate] = useState<IPaginate>({
    page: 1, perPage: 10, lastPage: 1, total: 0,
  });

  const fetchServicesSocialAction = useCallback(async () => {
    const response = await httpGet('social-action/services', {
      params: {
        filter,
        ...paginate,
      },
    });
    return response.data;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, paginate?.page]);

  const { data, status } = useQuery(['services', paginate, filter], fetchServicesSocialAction, {
    refetchOnWindowFocus: false, refetchInterval: 10000, retry: false,
  });

  useEffect(() => {
    if (status === 'success') {
      setServices(data?.data);
      setPaginate(data?.pagination);
    }
  }, [data, filter, status]);

  const handleSearch = (value: string): void => {
    setPaginate({ ...paginate, page: 1 });
    setFilter({ search: value });
  };

  const handlePaginate = (payload: IPaginate): void => {
    setPaginate(payload);
  };

  const breadcrumbs = {
    icon: GoChecklist,
    links: [{ path: '', title: 'Lista de Serviços' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Container>
        <HeaderFilterPlus handleSearch={handleSearch} handlePlus={() => history.push('/social-action/services/create')}/>

        <Grid container spacing={3} justify="space-between">
          <Box p={2}><b>Total</b></Box>
          <Box p={2}><b>{services?.length}</b></Box>
        </Grid>

        {services?.map((service:any) => (
          <Card service={service} key={service.id} />
        ))}

        <Pagination paginate={paginate} handlePaginate={handlePaginate} />
      </Container>
    </Layout>
  );
};

export default ServiceList;
